import {mapState} from "vuex";
import util from "@/mixins/util";
import {getTokenObj, loginTokenSet, logout, markTempPasswordLoginFlow} from "@/mixins/Auth";
import moment from "moment";
import Swal from 'sweetalert2'
import EventBus from "@/utils/event-bus.js";
import {kakaoService} from "@/plugins/kakaoService.js";
import checkLevelMixins from "@/mixins/checkLevelMixins.js";
import alertMixins from "@/mixins/alertMixins";
export default {
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    mixins:[checkLevelMixins, alertMixins],
    data() {
        return {
            loginListeners: new Set(),
        }
    },
    beforeDestroy() {
        this.removeLoginMessageListeners();
    },
    methods: {
        checkTimeLimit() {
            let timeLimit = this.$localStorage.get('timeLimit');
            if (timeLimit) {
                let nowTime = moment().add("-10", "m").format('YYYY-MM-DD HH:mm:ss');
                if (timeLimit < nowTime) {
                    this.$localStorage.set('timeLimit', moment().format('YYYY-MM-DD HH:mm:ss'))
                    Swal.fire({
                        title: '',
                        html: '10분 초과하였습니다. 재로그인 해주세요.',
                        confirmButtonText: '확인',
                        customClass: 'nhAlert_main',
                        didClose: () => {
                            return logout();
                        }
                    })
                } else {
                    this.$localStorage.set('timeLimit', moment().format('YYYY-MM-DD HH:mm:ss'))
                    return true;
                }
            } else {
                return false;
            }

        },
        checkCreateAdmin() {
            let type = this.getAdminType();
            if (type === 'creator') {
                return true;
            }
            return false;
        },
        getAdminType() {
            let tokenObj = getTokenObj();
            if (tokenObj.g_type === 'admin') {
                return 'admin'
            } else if (tokenObj.g_type === 'creator') {
                return 'creator'
            } else if (tokenObj.g_type === 'member') {
                return 'member'
            } else if (tokenObj.g_type === 'video') {
                return 'video'
            }
            return false;
        },
        isMediaPartner() {
            if (util.isEmpty(this.UserInfo.mpTypeEnums)) {
                return false;
            }
            return this.UserInfo.mpTypeEnums.indexOf('MEDIA') > -1
        },
        isAdPartner() {
            if (util.isEmpty(this.UserInfo.mpTypeEnums)) {
                return false;
            }
            return this.UserInfo.mpTypeEnums.indexOf('ADVERTISEMENT') > -1
        },
        isPartnerType(type) {
            if (util.isEmpty(this.UserInfo.mpTypeEnums)) {
                return false;
            }
            return this.UserInfo.mpTypeEnums.indexOf(type) > -1
        },
        loginSns(res, socialType = '') {
            if (res.code === 1) {
                markTempPasswordLoginFlow();
                loginTokenSet(res.result.data.accessToken);
                if (res.result.data.meEnd === false) {
                    this.$localStorage.remove('qrAuth');
                    // 소셜 가입 단계 구성에 사용(카카오는 본인인증 생략). 매 로그인마다 갱신해 이전 값이 남지 않게 한다.
                    this.$localStorage.set('socialType', socialType);
                    this.$router.push('/auth/social/register')
                } else {
                    this.checkLevel();
                }
            } else if(res.code === -260) {
                this.createConfirm({
                    content: '정지된 계정입니다. 정지를 해지해주세요.',
                    confirmText: '네',
                    cancelText: '아니오',
                    confirm: () => {
                        this.$router.push('/suspend?id=' + res.result);
                    },
                })
            } else {
                EventBus.$emit('apiLoading', false);
                // 로그인 실패 정리는 해당 소셜에만 적용한다 (타 소셜 실패 시 카카오 연결 해제 방지)
                if (socialType === 'KAKAO') {
                    kakaoService().disconnect()
                }
                this.createAlert({
                    title: '로그인 에러',
                    content: `로그인에 실패했습니다.`,
                    btnText: '확인',
                    hide: () => {
                    }
                });
            }
        },


        async loginUnity(res) {
            try {
                if (res.Info.type !== 1) {
                    await this.handleFailedLogin;
                    return;
                }
                const {token, mb_end} = res.List;

                await this.setupLoginMessageListener(token, mb_end);

            } catch (error) {
                console.error('Error in successful login handling:', error);
                throw error;
            }
        },
        setupLoginMessageListener(token = '', isRegister = 0, isFinished = true) {
            const messageHandler = (e) => {
                if (e.data !== 'game-login-request') return;

                const response = {
                    type: 'game-login-result',
                    isFinished,
                    token,
                    isRegister
                };

                e.source?.postMessage(response, {targetOrigin: '*'});

                console.log(response);
            };

            window.addEventListener('message', messageHandler);
            this.loginListeners.add(messageHandler);
        },

        removeLoginMessageListeners() {
            this.loginListeners.forEach(listener => {
                window.removeEventListener('message', listener);
            });
            this.loginListeners.clear();
        },

        async handleFailedLogin() {
            EventBus.$emit('apiLoading', false);
            this.setupLoginMessageListener('', 0, false);

        },
    },
}
